module.exports = __webpack_public_path__ + "static/media/1JL1837.5bf867a3.jpg";